import React from "react"
import { useStaticQuery, Link, graphql } from "gatsby"
import styles from "../../styles/global.module.scss"

export default function AlertBanner({ metadata }) {
  let AlertLink = ({ alert_data, children }) => {
    if (alert_data.new_tab === true) {
      return (
        <a href={alert_data.link} target="_blank" title={alert_data.text}>
          {children}
        </a>
      )
    } else {
      return (
        <Link to={alert_data.link} title={alert_data.text}>
          {children}
        </Link>
      )
    }
  }

  const { settings } = useStaticQuery(graphql`
    query {
      settings: allModulesYaml(filter: { alert_id: { eq: "alert_001" } }) {
        edges {
          node {
            alert_id
            text
            link
            new_tab
            color
            background
            is_active
          }
        }
      }
    }
  `)

  let alert_data = {}
  let color, background

  // If query finds data, set alert_data object
  if (settings) {
    alert_data = settings.edges[0].node
  }

  if (alert_data && alert_data.is_active === true) {
    color = alert_data.color
    background = alert_data.background
    return (
      <div
        className={styles.alertBanner}
        style={{
          color,
          background,
        }}
      >
        {alert_data.link ? (
          <AlertLink alert_data={alert_data}>{alert_data.text}</AlertLink>
        ) : (
          <p>{alert_data.text}</p>
        )}
      </div>
    )
  } else {
    return null
  }
}
